import React from "react";
import {
  Show,
  TextField,
  RichTextField,
  BooleanField,
  DateField,
  TabbedShowLayout,
  Tab,
  SingleFieldList,
  ChipField,
  ReferenceField,
  translate
} from "admin-on-rest";
import restClient from "../../../restClient";
import {GET_ONE} from "admin-on-rest";
import {connect} from "react-redux";
import RelationsManyField from "../../../components/RelationsManyField";
import ImageField from "../../../components/CRM/ImageField";
import Avatar from "material-ui/Avatar";
import {listStyle} from "./style";
import {viewStyle} from "./style";
import ReferenceArrayField from "../../../components/ReferenceArrayField";
import ReferenceSelectGrid from "../../../components/ReferenceSelectGrid";
import StoreFilter from "../Stores/StoreFilter";
import ActionBar from "../../../components/CRM/ActionBar/";

const PromoTitleBase = ({record, translate}) => {
  return (
    <span>
      {translate("resources.promos.titleEdit")}{" "}
      {record ? `"${record.name}"` : ""}
    </span>
  );
};

const PromoTitle = translate(PromoTitleBase);

const FullNameField = ({record = {}, avatar = ''}) => (
  <div style={listStyle.textFieldContainer}>
    <Avatar src={avatar} />
    <span style={listStyle.textFieldStyle}>
      {record.first_name} {record.last_name}
    </span>
  </div>
);

const DisplayLocationFieldBase = ({record, translate}) => {
  if (record.display_location) {
    const displayLocation = record.display_location.trim().toLowerCase();

    switch (displayLocation) {
      case "before data input": {
        record.display_location_translated = translate(
          "resources.promos.inputs.displayLocation.inputBefore"
        );
        break;
      }
      case "after data input": {
        record.display_location_translated = translate(
          "resources.promos.inputs.displayLocation.inputAfter"
        );
        break;
      }
      default:
        record.display_location_translated = record.display_location;
        break;
    }
  }

  return (
    <div>
      <span style={viewStyle.labelFieldStyle}>
        {translate("resources.promos.fields.displayLocation")}{" "}
      </span>
      <div>
        <p>{record ? `${record.display_location_translated}` : ""}</p>
      </div>
    </div>
  );
};

const DisplayLocationField = translate(DisplayLocationFieldBase);

const InputHeaderBase = ({translate, header, headerStyle}) => (
  <div style={headerStyle}>
    <span>{translate(header)}:</span>
  </div>
);

const InputHeader = translate(InputHeaderBase);

class PromoShowItem extends React.Component {
  constructor(props) {
    super(props)
  
    this.state = {
      marketingPartnerValue: ''       
    }
  }
  
  componentDidMount() {
    if (this.props.configuration && this.props.configuration.promos) {
      const {history} = this.props;
      if (this.props.configuration.promos.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.promos.enabled !== true)
        history.replace(`/`);
    }

    if(!this.state.marketingPartnerValue && this.props.record) {
      return restClient(GET_ONE, "marketing_partners", {id: this.props.record.marketing_partner_id})
        .then(marketingPartner => {
          return this.setState({
            marketingPartnerValue: marketingPartner.data.name, 
            marketing_id: marketingPartner.data.id
          })
      })
    }
  }

  render() {
    const props = {...this.props};
    const { marketingPartnerValue } = this.state;
    
    return (
      <Show title={<PromoTitle />} {...props}>
        <TabbedShowLayout {...props}>
          <Tab label="resources.promos.titleTab1">
            <DateField
              style={viewStyle.containerStyle}
              label="resources.promos.fields.validFrom"
              source="valid_from"
            />
            <DateField
              style={viewStyle.containerStyle}
              label="resources.promos.fields.validTo"
              source="valid_to"
            />
            <div style={viewStyle.clearFloatContainer} />
            <RelationsManyField
              style={viewStyle.textFieldStyle}
              label="resources.promos.fields.industry"
              target="promo_id"
              source="industries_id"
              reference="industries"
            >
              <SingleFieldList>
                <ChipField source="name" />
              </SingleFieldList>
            </RelationsManyField>

            <ReferenceField
              style={viewStyle.textFieldStyle}
              label="resources.promos.fields.marketingPartner"
              source="marketing_partner_id"
              reference="marketing_partners"
              linkType={false}
            >
              <TextField source="name" />
            </ReferenceField>
            <TextField
              style={viewStyle.textFieldStyle}
              source="text"
              label="resources.promos.fields.description"
            />
            <ImageField
              style={viewStyle.imageContainerStyle}
              source="images.large"
              src="src"
              title="title"
              validDimensions={this.props.imageLabel.large}
            />

            <ImageField
              style={viewStyle.imageContainerStyle}
              source="images.small"
              src="src"
              title="title"
              validDimensions={this.props.imageLabel.small}
            />
            <div style={viewStyle.clearFloatContainer} />
            <TextField
              style={viewStyle.textFieldStyle}
              source="external_link"
              label="resources.promos.fields.externalLink"
            />
            <BooleanField
              style={viewStyle.booleanContainerStyle}
              elStyle={viewStyle.booleanFieldStyle}
              label="resources.promos.fields.active"
              source="active"
            />
            <BooleanField
              style={viewStyle.booleanContainerStyle}
              elStyle={viewStyle.booleanFieldStyle}
              label="resources.promos.inputs.displayOnTablet"
              source="display_on_tablet"
            />
            <BooleanField
              style={viewStyle.booleanContainerStyle}
              elStyle={viewStyle.booleanFieldStyle}
              label="resources.promos.inputs.displayOnWeb"
              source="display_on_web"
            />
            <div style={viewStyle.clearFloatContainer} />
            <TextField
              style={viewStyle.textFieldStyle}
              source="voucher_code"
              label="resources.promos.inputs.voucherCode"
            />
            <RichTextField
              style={viewStyle.textFieldStyle}
              label="resources.promos.fields.tosText"
              source="tos"
            />
            <DisplayLocationField source="display_location" />
          </Tab>
          <Tab label="resources.promos.titleTab2">
            <ReferenceArrayField
              addLabel={false}
              reference="kiosks"
              source="kiosk_ids"
              location={props.location}
              actions={
                <ActionBar
                  createButton={false}
                  deleteButton={false}
                  withActionMenu={false}
                />
              }
              filters={<StoreFilter isNested={true} />}
            >
              <ReferenceSelectGrid
                options={{
                  multiSelectable: false,
                  selectable: false
                }}
                headerOptions={{
                  adjustForCheckbox: false,
                  displaySelectAll: false,
                  enableSelectAll: false
                }}
                bodyOptions={{
                  displayRowCheckbox: false,
                  deselectOnClickaway: false,
                  showRowHover: true
                }}
                rowOptions={{selectable: false}}
              >
                <TextField
                  label="resources.stores.fields.storeName"
                  source="name"
                />
                <ReferenceField
                  label="resources.stores.fields.storeOwner"
                  source="partner_id"
                  reference="partners"
                  linkType={false}
                >
                  <FullNameField source="first_name" avatar={props.avatar} />
                </ReferenceField>

                <TextField
                  label="resources.stores.fields.email"
                  source="email"
                />

                <TextField
                  label="resources.stores.fields.deviceSerialNumber"
                  source="device_serial_number"
                />

                <BooleanField
                  elStyle={listStyle.booleanFieldStyle}
                  label="resources.stores.fields.active"
                  source="active"
                />
              </ReferenceSelectGrid>
            </ReferenceArrayField>
          </Tab>

          <Tab
            label="resources.promos.titleTab4"
          >
            {marketingPartnerValue !== 'william_hill'
            && marketingPartnerValue !== 'mrgreen'
            && marketingPartnerValue !== 'cashbacker'
            && <InputHeader
                  header="resources.promos.selectToSeeExtraTab"
                  style={{margin: "10px"}}
                />}


              {marketingPartnerValue === 'mrgreen' &&
              <Tab
                label="resources.promos.titleTab4"
              >
                <div style={viewStyle.clearFloatContainer} />
                <InputHeader
                  header="resources.promos.inputs.marketingPartnerTab.mrGreen.name"
                  headerStyle={viewStyle.headerContainer}
                  style={viewStyle.headerStyle}
                />
                <TextField
                  style={viewStyle.textFieldStyle}
                  source="extra.mrgreen.lpid"
                  label="resources.promos.inputs.marketingPartnerTab.mrGreen.lpid"
                />
                <TextField
                  style={viewStyle.textFieldStyle}
                  source="extra.mrgreen.bid"
                  label="resources.promos.inputs.marketingPartnerTab.mrGreen.bid"
                />
                <div style={viewStyle.clearFloatContainer} />
              </Tab>}


            {marketingPartnerValue === 'william_hill' &&
            <Tab
                label="resources.promos.titleTab4"
            >
              <div style={viewStyle.clearFloatContainer} />
              <InputHeader
                  header="resources.promos.inputs.marketingPartnerTab.william_hill.name"
                  headerStyle={viewStyle.headerContainer}
                  style={viewStyle.headerStyle}
              />
              <TextField
                  style={viewStyle.textFieldStyle}
                  source="extra.william_hill.bid"
                  label="resources.promos.inputs.marketingPartnerTab.william_hill.bid"
              />
              <div style={viewStyle.clearFloatContainer} />
            </Tab>}


            {marketingPartnerValue === 'cashbacker' &&
              <Tab
                label="resources.promos.titleTab4"
              >
                <div style={viewStyle.clearFloatContainer} />
                <InputHeader
                  header="resources.promos.inputs.marketingPartnerTab.cashbacker.name"
                  headerStyle={viewStyle.headerContainer}
                  style={viewStyle.headerStyle}
                />
                <TextField
                  style={viewStyle.textFieldStyle}
                  source="extra.cashbacker.campaign_id"
                  label="resources.promos.inputs.marketingPartnerTab.cashbacker.campaign_id"
                />
                <BooleanField
                  style={viewStyle.booleanContainerStyle}
                  elStyle={viewStyle.booleanFieldStyle}
                  label="resources.promos.inputs.giftcard"
                  source="extra.cashbacker.gift_card_enabled"
                />
                <div style={viewStyle.clearFloatContainer} />
              </Tab>}
          </Tab>
        </TabbedShowLayout>
      </Show>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    id: decodeURIComponent(props.match.params.id),
    configuration: state.configuration,
    record: state.admin.resources[props.resource]
      ? state.admin.resources[props.resource].data[
          decodeURIComponent(props.match.params.id)
        ]
      : null,
    avatar: state.images.avatar_logo
  };
};

export default connect(mapStateToProps)(translate(PromoShowItem));



// WEBPACK FOOTER //
// ./src/containers/CRM/Promos/PromoShowItem.js